import {DomainObject, oneOf} from 'shared/store';
import {action, observable, computed} from 'mobx';
import {daysFromNow, calendarDate} from 'shared/tools';
import {absoluteTimestampDate} from 'shared/tools/dates';

class NmbrPayroll extends DomainObject {
  @observable status;
  @observable approvalDueDate;
  @observable nextPayrollApprovalDueDate;
  @observable payDate;
  @observable type;

  @action merge(other, _) {
    super.merge(other, {
      status: oneOf(['draft', 'approved', 'paid', 'failed', 'processing']),
      type: oneOf(['regular', 'off_cycle', 'historical'])
    });
  }

  @computed get approvalDueDateView() {
    return absoluteTimestampDate(this.approvalDueDate, {includeDayOfWeek: true});
  }

  @computed get approvalDueDateDaysFromNow() {
    return daysFromNow(this.approvalDueDate);
  }

  @computed get nextPayrollApprovalDueDateView() {
    return calendarDate(this.nextPayrollApprovalDueDate);
  }

  @computed get nextPayrollApprovalDueDateDaysFromNow() {
    return daysFromNow(this.nextPayrollApprovalDueDate);
  }

  @computed get payDateView() {
    return calendarDate(this.payDate);
  }

  @computed get payDateDaysFromNow() {
    return daysFromNow(this.payDate);
  }

  @computed get payrollStatusColor() {
    switch (this.status) {
      case 'approved':
      case 'paid':
      case 'processing':
        return 'grass';
      case 'draft':
        return 'turquoise';
      case 'failed':
        return 'scarlet';
      default:
        throw new Error(`Status ${this.status} is not supported.`);
    }
  }

  @computed get payrollDates() {
    const datesArray = [];

    if (this.status === 'draft') {
      datesArray.push({
        dateName: 'Payroll Approval Due Date',
        date: this.approvalDueDateView,
        daysFromNow: this.approvalDueDateDaysFromNow,
        colour: this.approvalDueDateColour
      });
    }

    datesArray.push({
      dateName: 'Pay Date',
      date: this.payDateView,
      daysFromNow: this.payDateDaysFromNow
    });

    if (this.status !== 'draft' && this.nextPayrollApprovalDueDate) {
      datesArray.push({
        dateName: 'Next Payroll Approval Due Date',
        date: this.nextPayrollApprovalDueDateView,
        daysFromNow: this.nextPayrollApprovalDueDateDaysFromNow,
        colour: this.approvalDueDateColour
      })
    }

    return datesArray;
  }

  @computed get approvalDueDateColour() {
    if (this.approvalDueDateDaysFromNow === 2) {
      return 'sun';
    } else if (this.approvalDueDateDaysFromNow <= 1) {
      return 'scarlet';
    }
  }
}

export default NmbrPayroll;
